__turbopack_context__.v({
  "textWrapper": "ResourceCard-module__LPMp4W__textWrapper",
  "wrapper": "ResourceCard-module__LPMp4W__wrapper",
});
